import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassigned: {
		id: 'portal-settings-request-groups.controllers.get-request-form-options.unassigned',
		defaultMessage: 'Unassigned',
		description:
			'Category label for request type which not been assigned to any ITSM practice category',
	},
});
